import { AxiosResponse } from 'axios';
import { apiClient, getAuthHeaders } from './index';
import { CommunityModeratorResponse } from './types';

export const communityModeratorApi = {
  /**
   * 주어진 토큰의 모더레이터 목록 및 활동 이력 조회
   * @param tokenAddress 토큰 주소
   * @returns 커뮤니티 모더레이터 정보
   */
  async getCommunityModerators(tokenAddress: string): Promise<CommunityModeratorResponse> {
    try {
      const response: AxiosResponse<any> = await apiClient.get(
        `/community-moderator/token/${tokenAddress}`,
        {
          headers: getAuthHeaders(),
        }
      );

      return response.data.data;
    } catch (error) {
      console.error('❌ GET /community-moderator/token/:tokenAddress 에러:', error);
      throw error;
    }
  },

  /**
   * 커뮤니티 ID 기준으로 토큰-Moderator 매칭 정보를 업데이트하고 결과를 반환합니다.
   * @param request communityId와 (선택적) tokenAddress
   * @returns 커뮤니티 모더레이터 정보
   */
  async updateByCommunity(request: {
    communityId: string;
    tokenAddress?: string;
  }): Promise<CommunityModeratorResponse> {
    try {
      const response: AxiosResponse<any> = await apiClient.post(
        '/community-moderator/update-by-community',
        request,
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data.data;
    } catch (error) {
      console.error('❌ POST /community-moderator/update-by-community 에러:', error);
      throw error;
    }
  },
};
